import React from 'react'
import Swiper from 'swiper'
import http from 'src/helper/http'
import 'swiper/swiper-bundle.min.css'
import './index.less'
import showToast from '../toast'
import Loading from '../loading-svga'
import brower from 'src/helper/brower'
import { isRtl } from 'src/helper/tool'

import CertificateModal from '../certificate-modal'
import lang from '../lang'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
    this.swiperGiftRef = React.createRef()
  }

  state = {
    slideIndex: 0,
    imgPath: '/img/activity/national-star/',
    rewardInfo: {}, // 奖励信息
    activeRewardItem: [], // 当前奖励列表
    activeGiftId: '', // 当前礼物ID
    activeGiftImg: '', // 当前礼物图片url
    activeStage: 0, // 当前阶段
    rewardList: [], // 奖励列表
    visible: false,
    videoVap: {},
    isLoading: false
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { giftList } = this.props
    const that = this
    if (JSON.stringify(giftList) !== JSON.stringify(prevProps.giftList) && giftList.length) {
      this.setState({
        toastContent: lang.toast_msg
      })
      if (!this.swiperGift) {
        this.swiperGift = new Swiper(this.swiperGiftRef.current, {
          autoplay: false,
          slidesPerView: 1
        })

        this.swiperGift.on('slideChange', (slide) => {
          const { activeIndex } = slide
          that.setState({
            slideIndex: activeIndex,
            activeGiftId: that.props.giftList[activeIndex].giftid
          })
          that.getRewardInfo(that.props.giftList[activeIndex].giftid)
        })
      }

      this.setState({
        activeGiftId: giftList[0].giftid
      })
      this.getRewardInfo(giftList[0].giftid)
      this.getRewardlist()
    }
  }

  goToSlide = (index) => {
    if (this.swiperGift) {
      this.swiperGift.slideTo(index)
    }
  }

  onSlidePrev = () => {
    if (this.state.slideIndex === 0) return
    this.swiperGift && this.swiperGift.slidePrev()
  }

  onSlideNext = () => {
    if (this.state.slideIndex === (this.props.giftList.length - 1)) return
    this.swiperGift && this.swiperGift.slideNext()
  }

  // 获取奖励信息
  getRewardInfo = async (itemId) => {
    const data = await http.post('/web/activity/rewardinfo', {
      activityKey: 'nationalStar',
      rewardType: 'task',
      itemId
    })

    const { code, res } = data
    if (code === 0 && res) {
      let activeStage = 0
      const copyRewardInfo = JSON.parse(JSON.stringify(this.state.rewardInfo))
      // 接口返回的数据会超过3条，但业务只用到3条
      copyRewardInfo[itemId] = res.slice(0, 3)

      for (let i = 0; i < copyRewardInfo.length; i++) {
        if (copyRewardInfo[i].canGet === 1) {
          activeStage = i
        }
      }

      this.setState({
        rewardInfo: copyRewardInfo,
        activeRewardItem: copyRewardInfo[itemId],
        activeStage
      })
    }
  }

  // 获取奖励列表
  async getRewardlist() {
    const data = await http.post('/web/activity/rewardlist', {
      activityKey: 'nationalStar',
      rewardType: 'task'
    })

    const { code, res } = data
    if (code === 0 && res) {
      this.setState({
        rewardList: res
      })
    }
  }

  // 获取当前礼物进度
  getProgress = (rewardInfo, activeGiftId) => {
    const { language } = this.props
    if (rewardInfo[activeGiftId]) {
      const stageItem = rewardInfo[activeGiftId][0]
      let percent = stageItem.percent
      // 进度大于50%并且小于66%的时候显示50% UI 要求
      if (percent > 50 && percent < 66) {
        percent = 50
      }
      const progress = 100 - percent

      return isRtl(language) ? progress : '-' + progress
    }

    return 100
  }

  // 获取礼物信息
  getGiftName = () => {
    const { giftList } = this.props
    const { activeRewardItem, activeStage } = this.state
    if (giftList && giftList.length) {
      if (activeRewardItem.length) {
        const { rewardCondition } = activeRewardItem[activeStage]
        if (rewardCondition === 0) {
          return ''
        } else {
          let txt = this.props.lang.cheer_rewards_description2.replace(/\{0\}/g, rewardCondition)
          return (txt)
        }
      }
      // return (`Need to send 5 [${giftItem.name}] to unlock following rewards`)
    }
    return ''
  }

  // 获取按钮状态
  getBtnClass = () => {
    const { activeStage, activeGiftId, rewardInfo } = this.state
    if (rewardInfo[activeGiftId]) {
      const rewardItem = rewardInfo[activeGiftId][activeStage]
      // 可以领取并且没有领取
      if (rewardItem.canGet === 1 && rewardItem.alreadyGet === 0) {
        return 'active'
      }
    }

    return ''
  }
  // 领取礼物
  onGetReward = async () => {
    const {
      activeStage,
      activeGiftId,
      rewardInfo,
      rewardList,
      slideIndex
    } = this.state
    this.setState({
      isLoading: true
    })

    if (rewardInfo[activeGiftId]) {
      const rewardItem = rewardInfo[activeGiftId][activeStage]
      // 可以领取并且没有领取
      if (rewardItem.canGet === 1 && rewardItem.alreadyGet === 0) {
        Loading.show()

        const data = await http.post('/web/activity/getreward', {
          rewardType: 'task',
          activityKey: 'nationalStar',
          itemId: activeGiftId,
          id: rewardList[activeStage].id
        })

        const { code, res } = data
        Loading.hide()

        if (code === 0 && res) {
          this.setState({
            activeGiftImg: this.props.giftList[slideIndex].image,
            visible: true
          })
          this.getRewardInfo(activeGiftId)
          this.props.getRedpoint()
        } else {
          showToast(this.props.lang.toast_msg, 3000)
        }
      }
    }
    return false
  }

  getCurrentCountLang = () => {
    const { lang } = this.props
    const { activeStage, activeRewardItem } = this.state
    if (activeRewardItem.length) {
      const count = activeRewardItem[activeStage].score
      return lang.current_gift_quantity.replace(/\{0\}/g, count)
    }
    return ''
  }

  // 切换 stage
  onChangeStage = (index) => {
    this.setState({
      activeStage: index
    })
  }

  onToggleModal = async () => {
    this.setState({
      visible: !this.state.visible
    })
  }

  // 播放媒体
  onPlayMedia = (e, reward) => {
    e.stopPropagation()
    if (reward.show_url) {
      this.props.onSetActiveMedia(reward)
    }
  }

  getDays = (days) => {
    const { lang } = this.props
    let text = lang.days.replace(/\{0\}/g, days)
    return text
  }

  // 获取多语言name
  getLangName = (item) => {
    const { language } = this.props
    const txt = item[`name_${language}`] || item.name
    return txt
  }

  // 获取stage title
  getStageTitle = (index) => {
    const { lang } = this.props
    const titles = {
      'stage_0': lang.stage_1,
      'stage_1': lang.stage_2,
      'stage_2': lang.stage_3
    }

    return titles['stage_' + index]
  }

  render() {
    const {
      giftList,
      lang,
      language,
      userInfo
    } = this.props
    const {
      rewardInfo,
      activeGiftId,
      activeStage,
      rewardList,
      visible,
      activeGiftImg,
      activeRewardItem
    } = this.state
    return (
      <div className='tab-task'>
        <div className='hd'>
          <h2>{lang.cheer_rewards2}</h2>
        </div>
        <div className='bd'>
          {/* 背景图层 */}
          <div className="bd-bg">
            <div className="bd-bg-list">
              <div className="top">
                <img src="/img/activity/national-star/img_box_bg_frame_top@2x.png" />
                <p className="title">
                  {lang.cheer_rewards_description1}
                </p>
              </div>
              <div className="min">
                <div className="img-list">
                  <div className="img-contant">
                    <div className="swiper-container" ref={this.swiperGiftRef}>
                      <div className="swiper-wrapper">
                        {
                          giftList &&
                          giftList.map((item) => {
                            return (
                              <div
                                className="swiper-slide"
                                key={item.image}
                              >
                                <div className="img-item">
                                  <div className="img-wrap">
                                    <img src={item.image} />
                                  </div>
                                  <div className="text-wrap">
                                    <i className="icon-wrap">
                                      <img src="/img/activity/national-star/icon_coins@2x.png" />
                                    </i>
                                    {item.gold}
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                  {
                    giftList.length > 1 && (
                      <div
                        className={`prev ${this.state.slideIndex === 0 ? 'disable' : ''}`}
                        onClick={this.onSlidePrev}
                      ></div>
                    )
                  }
                  {
                    giftList.length > 1 && (
                      <div className={`next ${this.state.slideIndex === giftList.length - 1 ? 'disable' : ''}`} onClick={this.onSlideNext}></div>
                    )
                  }
                </div>
                <div className="stage-wrap">
                  <div className="count-wrap">
                    {this.getCurrentCountLang()}
                  </div>
                  <div className="stage-progress">
                    <div className={`stage-progress-frame ${isRtl(language) ? 'arlang' : ''}`}>
                      <img
                        style={{
                          transform: `translateX(${this.getProgress(rewardInfo, activeGiftId)}%) ${isRtl(language) ? 'rotate(180deg)' : ''}`
                        }}
                        src="/img/activity/national-star/img_progress_bar@2x.png"
                        alt=""
                      />
                    </div>
                    <div className={`stage-progress-list ${isRtl(language) ? 'arlang' : ''}`}>
                      {
                        activeRewardItem.length &&
                        activeRewardItem.map((giftItem, giftIndex) => {
                          return (
                            <div
                              className={
                                `stage-item
                                ${giftItem.canGet === 1 ? 'waiting' : ''}
                                ${giftItem.alreadyGet === 1 ? 'received' : ''}
                                ${activeStage === giftIndex ? 'active' : ''}`
                              }
                              key={giftItem.id}
                              onClick={() => this.onChangeStage(giftIndex)}
                            >
                              {
                                giftIndex === 0 && (
                                  <img className='stage-img' src={`/img/activity/national-star/${giftItem.canGet === 0 ? 'icon_cheer_reward_lv1_d@2x.png' : 'icon_cheer_reward_lv1_n@2x.png'}`} />
                                )
                              }
                              {
                                giftIndex === 1 && (
                                  <img className='stage-img' src={`/img/activity/national-star/${giftItem.canGet === 0 ? 'icon_cheer_reward_lv2_d@2x.png' : 'icon_cheer_reward_lv2_n@2x.png'}`} />
                                )
                              }
                              {
                                giftIndex === 2 && (
                                  <img className='stage-img' src={`/img/activity/national-star/${giftItem.canGet === 0 ? 'icon_cheer_reward_lv3_d@2x.png' : 'icon_cheer_reward_lv3_n@2x.png'}`} />
                                )
                              }
                              <p>
                                <img className='left' src="/img/activity/national-star/icon_arrow_d@2x.png" alt="" />
                                {/* Stage {giftIndex + 1} */}
                                {this.getStageTitle(giftIndex)}
                                <img className='right' src="/img/activity/national-star/icon_arrow_d@2x.png" alt="" />
                              </p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className="stage-gift">
                    <span className="title">
                      {this.getStageTitle(activeStage)}
                    </span>
                    <div className="desc">
                      {this.getGiftName()}
                    </div>
                    <div className="gift-list">
                      {
                        rewardList.length &&
                        rewardList[activeStage].reward.map((rewardItem, rewardIndex) => {
                          return (
                            <div className="gift-item" key={rewardItem.image_url}>
                              <div
                                className={`img-wrap ${rewardItem.show_url ? 'video' : ''} ${rewardItem.days === 0 ? 'no-days' : ''}`}
                                onClick={(e) => this.onPlayMedia(e, rewardItem)}
                              >
                                {
                                  rewardItem.show_url && (<div className="icon-video"></div>)
                                }
                                <img src={rewardItem.image_url} />
                                {
                                  rewardItem.days > 0 && (
                                    <div className="tag">
                                      x {this.getDays(rewardItem.days)}
                                    </div>
                                  )
                                }
                              </div>
                              <p className="name">
                                {this.getLangName(rewardItem)}
                              </p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom">
                <img src="/img/activity/national-star/img_box_bg_frame_bot@2x.png" />
                <div
                  className={`btn-wrap ${this.getBtnClass(this)}`}
                  onClick={this.onGetReward}
                >
                  {lang.receive}
                </div>
              </div>
            </div>
          </div>
          {/* 背景图层 */}
        </div>
        <CertificateModal
          lang={lang}
          language={language}
          visible={visible}
          userInfo={userInfo}
          giftUrl={activeGiftImg}
          onToggleModal={this.onToggleModal}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/tab-task/index.js